import React from 'react'
import './styles.css'
import Form from '../components/Form'
import BarHOME from '../components/BarHOME'
import NavBar1 from '../components/NavBar1'
import Footer from '../components/Footer'
import BarCONTATO from '../components/BarCONTATO'
import Helmet from 'react-helmet'
import wa from '../assets/btn_WhatsApp.png'
 
export default class IndexPage extends React.Component {
    state = {
        firstName: "",
        lastName: "",
    }

    handleInputChange = event => {
        const target = event.target
        const value = target.value
        const name = target.name

        this.setState({
            [name]: value,
        })
    }

    handleSubmit = event => {
        event.preventDefault()
        alert(`Welcome ${this.state.firstName} ${this.state.lastName}!`)
    }

    render () {
        return (
            <div className='font-al-8'>
                <Helmet>
                    <title>Celeste bolos doces & salgados - Contato</title>
                </Helmet>
                <BarHOME/>
                <NavBar1 />
                <BarCONTATO />
                <div className='sm:flex md:flex-cols lg:flex-row justify-between font-al-8 items-center'>
                    <div>
                        <div className='flex flex-wrap justify-center'>
                            <div className='my-10'>
                                <div>
                                    <Form/>
                                </div>
                            </div>
                            <div className='text-center lg:mx-20 mx-5 pt-10'>
                                <div>
                                    <div className='text-center'>
                                        <p className="animation-ronsof-one font-ronsof-eight pt-1">(11) 9 5420 - 9626</p>
                                        <p className="animation-ronsof-one font-ronsof-eight pt-1">(11) 4649 - 0629</p>
                                    </div>
                                    
                                    <div className="animation-ronsof-one font-ronsof-seven">seu orçamento </div>
                                    
                                    <p className="animation-ronsof-one font-ronsof-eight pt-1">
                                        Preencha o formulário
                                    </p>
                                    <div className="font-ronsof-five color-ronsof-six">
                                        <p className='animation-ronsof-one pt-1'>
                                            Solicite um orçamento sem compromisso.
                                        </p>
                                        <p className='animation-ronsof-one pt-1'>
                                            Entraremos em contato o mais rápido possível!
                                        </p>
                                    </div>
                                    <div className='flex flex-row justify-center pt-5'>
                                        <div className='my-1'>
                                            <div>
                                                <h1 className='animation-ronsof-one font-ronsof-eight'>Clique abaixo!</h1>
                                                <h1 className='animation-ronsof-one font-ronsof-five color-ronsof-six'>Converse agora mesmo com a nossa equipe!</h1>
                                            </div>
                                            <div className='text-center px-10 py-10 items-center mt-4 sm:mt-0 sm:flex-row'>
                                                <a href='http://api.whatsapp.com/send?1=pt_BR&phone=5511954209626'>
                                                    <img className='text-center w-16 animation-ronsof-five lg:my-auto' src={wa} alt='whatsapp' />
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        )
   }
    
}